import React from 'react';

const TemplateHeader = ({children, className}) => {
    return (
        <div className={["fixed bg-white p-[10px] border-b border-b-[#e7eaec] w-[stretch] z-[1000] h-[53px] flex justify-between", className].join(" ")}>
            {children}
        </div>
    );
};

export default TemplateHeader;